import { Platform } from '@angular/cdk/platform';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ManageUsersAccountService } from '../services/manage-users-account.service';
import { STORE_URL } from '../shared/constants';
import { JWTPayloadData } from '../models/newModels/JWTPayloadData';

@Component({
    selector: 'app-wrong-device',
    templateUrl: './wrong-device.component.html',
    styleUrls: ['./wrong-device.component.scss'],
    standalone: false
})
export class WrongDeviceComponent {

  user: JWTPayloadData;
  public readonly STORE_URL = STORE_URL;

  constructor(
    private router: Router,
    public deviceService: DeviceDetectorService,
    private authenticationService: ManageUsersAccountService,
    public platform: Platform
  ) {
    this.user = this.authenticationService.currentUserValue;
    if (!!this.deviceService.isDesktop()) {
      this.router.navigateByUrl(this.authenticationService.getLoginUrlFromUserType(2));
    } else {
      // To Do: send email
    }
  }

  getProperLandingPage() {
    return this.authenticationService.navigateToLandingPage(this.user?.activeusertype?.usertypeid);
  }

}
